import SingleLineText from './SingleLineText';
import DoubleLineText from './DoubleLineText';
import ImgWithSingleLineText from './ImgWithSingleLineText';
import ImgWithDoubleLineText from './ImgWithDoubleLineText';

export { SingleLineText, DoubleLineText, ImgWithSingleLineText, ImgWithDoubleLineText};